import {
	SET_MISSIONS,
	SET_MISSION,
	CLEAR_MISSIONS,
	CLEAR_MISSION,
	ADD_MISSION,
	UPDATE_MISSION,
	REMOVE_MISSION,
} from './actionTypes';

export const mission = (state = {}, action) => {
	switch (action.type) {
		case SET_MISSION:
			return action.payload;
		case UPDATE_MISSION:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_MISSION:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_MISSIONS:
			return action.payload;
		case ADD_MISSION:
			return [...state, action.payload];
		case UPDATE_MISSION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_MISSION:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_MISSIONS:
			return [];
		default:
			return state;
	}
};
